module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/manu-management-component/edit-menu-management/edit-menu-management.component.css
// module id = ./src/app/manu-management-component/edit-menu-management/edit-menu-management.component.css
// module chunks = main